<template>
  <div class="hello">
    <div class="loginMask" v-if="showModel">
      <div class="login">
        <div class="clo" @click="closeEvet">
          <img src="../assets/image/close.png" alt="">
        </div>
        <div class="logonav">
          <div class="logo">
             <img src="../assets/image/searchlogo.png" alt="" >
            <!-- <img src="../assets/image/logo.png" alt=""> -->
          </div>
          <div class="fromList" v-if="formShow">
            <div class="tab">
              <div class="tablist" :class="{active:item.isActive}" v-for="(item,index) in tablist" :key="index" @click="tabEvent(index)">
                <span>{{item.name}}</span>
              </div>
            </div>
            <div class="line"></div>
            <div class="form" v-if="passwordShow">
              <div class="phone">
                <input type="text" class="myInput" v-model="form.phone" :placeholder="$t('language.phone')">
              </div>
              <div class="passworld">
                <input type="password" class="myInput" v-model="form.password" :placeholder="$t('language.parssworld')">
              </div>
              <div class="loginBtn" @click="loginPhone">
                <span>{{$t('language.login')}}</span>
              </div>
              <div class="forget">
                <span @click="forgetEvent">{{this.$t('language.Forget')}}?</span>
                <span class="register" @click="registerSh()">{{this.$t('language.register')}}</span>
              </div>
            </div>
            <!-- 手机号 验证码 -->
            <div class="form" v-else>
              <div class="phone">
                <input type="text" class="myInput" v-model="phoneCode.phone" :placeholder="$t('language.phone')">
              </div>
              <div class="code">
                <div class="codeNumber">
                  <input type="text" v-model="phoneCode.code" class="myInput">
                </div>
                <div class="codeBtn" @click="getCode" :class="{prohibit:isprohibit}">
                  <span>{{lastTimeContent}}</span>
                </div>
              </div>
              <div class="codeLogin"  @click="loginCode">
                <span>{{$t('language.login')}}</span>
              </div>
              <div class="forget">
                <span @click="forgetEvent">{{this.$t('language.Forget')}}?</span>
                <span class="register" @click="registerSh()">{{this.$t('language.register')}}</span>
              </div>
            </div>
          </div>

          <!-- 找回密码1 -->
          <div class="fromList" v-if="modify == 1">
            <div class="fromNav">
              <span>{{$t('language.Retrieve')}}</span>
            </div>
            <div class="lines"></div>
            <div class="phoneNumber">
              <input type="text" v-model="phoneCode.phone" class="myInput" :placeholder="$t('language.phone')">
            </div>
            <div class="code">
              <div class="codeNumber">
                <input type="text" v-model="phoneCode.code" class="myInput">
              </div>
             <div class="codeBtn" @click="getCode" :class="{prohibit:isprohibit}">
               <span>{{lastTimeContent}}</span>
             </div>
            </div>
            <div class="next last" @click="firstEvent">
              <span>{{$t('language.next')}}</span>
            </div>
          </div>

          <!-- 设置新的密码 -->
          <div class="fromList" v-if="modify == 2">
            <div class="fromNav">
              <span>{{$t('language.Change')}}</span>
            </div>
            <div class="lines"></div>
            <div class="phoneNumber">
              <input type="password" v-model="modifys.setPassword" class="myInput" :placeholder="$t('language.set')">
            </div>
            <div class="confirm">
              <input type="password" v-model="modifys.confirmPassword" class="myInput" :placeholder="$t('language.confirm')">
            </div>
            <div class="next last" @click="lastEvent">
              <span>{{$t('language.next')}}</span>
            </div>
          </div>
          <!-- 修改成功 -->
          <div class="fromList" v-if="modify == 3">
            <div class="fromNav">
              <span>{{$t('language.Retrieve')}}</span>
            </div>
            <div class="lines"></div>
            <div class="message">
              <span>{{$t('language.success')}}</span>
            </div>
            <div class="next last" style="margin-top: 119px;" @click="loginEvent">
              <span>{{$t('language.Log')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      showModel: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        modify: 0, // 控制
        isprohibit: false,
        passwordShow: true,
        formShow: true,
        ifExist: '',
        isLast: true,
        // 设置新密码
        modifys: {
          setPassword: '',
          confirmPassword: ''
        },
        // 账号密码
        form: {
          phone: '',
          password: '',
          loginType: ''
        },

        passCode: {
          phone: '',
          code: ''
        },
        lastTimeContent:'',
        //手机号验证码
        phoneCode: {
          phone: '',
          code: '',
          loginType: ''
        },
      }
    },

    created() {
      this.lastTimeContent = this.$t('language.code')
      this.maskShow = this.show;
      // 防止刷新后倒计时丢失
      if (localStorage.getItem('lastTime')) {
        let lastTime = localStorage.getItem('lastTime');
        let timer = setInterval(() => {
          if (lastTime > 0) {
            let lastTimeContent = lastTime + 's' + this.$t('language.Resend');
            lastTime--;
            localStorage.setItem('lastTime', lastTime);
          } else {
            this.isprohibit = false;
            window.clearInterval(timer);
            this.lastTimeContent = this.$t('language.code')
          }
        }, 1000);
      }
    },
    mounted() {

    },
    computed: {

      tablist() {
        var arr = [{
            name: this.$t('language.parsswordLogin'),
            isActive: true
          },
          {
            name: this.$t('language.sms'),
            isActive: false
          }
        ]
        return arr
      }
    },
    watch: {
      ifExist(newVal, oldVal) {
        if (Number(newVal) === 2 && this.isprohibit) {
          this.isLast = false;
          // 三个input框内都有值时需要做的操作
        } else {
          // 至少一个没有值
        }
      }
    },

    methods: {
     registerSh(){
       this.$emit('parentData',true)
     },
      tabEvent(index) {
        for (var i = 0; i < this.tablist.length; i++) {
          this.tablist[i].isActive = false;
        }
        this.tablist[index].isActive = true;
        if (this.tablist[index].name == '密码登录' || this.tablist[index].name == this.$t('language.parsswordLogin')) {
          this.passwordShow = true;
        } else {
          this.passwordShow = false;
        }
      },
      // 手机号密码登录
      loginPhone() {
        this.form.loginType = '2';
        this.$post('/User/login', this.form).then(res => {
          if (res.code == 200) {
            this.$message({
              message: this.$t('language.LoginSuccess'),
              type: 'success'
            });
            window.localStorage.setItem('access_token', res.data.access_token);
            window.localStorage.setItem('refresh_token', res.data.refresh_token);
            window.localStorage.setItem('expires_in',res.data.expires_in)
            window.localStorage.setItem('userInfo',JSON.stringify(res.data.userInfo))
            localStorage.setItem('languageSet','en')
             this.$emit('childByValue',false)
             this.$emit('userInfo',res.data.userInfo);
             // window.location.reload()
          }

        })
      },
      // 获取验证码
      getCode() {
        if (localStorage.getItem('lastTime') && localStorage.getItem('lastTime') > 0) {
          return
        } else {
          if (this.phoneCode.phone) {
            console.log(this.lastTimeContent);
            if (this.lastTimeContent == '发送验证码' || this.lastTimeContent == 'Send verification code') {

              var data = {
                phone: this.phoneCode.phone
              }

              this.$post('/Sms/sendCode', data).then(res => {
                if (res.code == 200) {
                    this.$message.success('发送成功')
                    let lastTime = 59;
                    let timer = setInterval(() => {
                      if (lastTime > 0) {
                        this.lastTimeContent = lastTime + 's' + this.$t('language.Resend');
                        console.log(this.lastTimeContent);
                        this.isprohibit = true;
                        lastTime--;
                        localStorage.setItem('lastTime', lastTime);
                      } else {
                        this.isprohibit = false;
                        window.clearInterval(timer);
                        this.lastTimeContent = this.$t('language.code')
                      }
                    }, 1000);
                }
              })
            }
          } else {
            this.$message({
              showClose: true,
              message:this.$t('language.phone'),
              type: 'error'
            });
          }
        }

      },
      // 手机号 验证码登录
      loginCode() {
        if (this.isLast) {
          this.phoneCode.loginType = '1';
          this.$post('/User/login', this.phoneCode).then(res => {
            if(res.code == 200){
              this.$message({
                message: this.$t('language.LoginSuccess'),
                type: 'success'
              });
              window.localStorage.setItem('access_token', res.data.access_token);
              window.localStorage.setItem('refresh_token', res.data.refresh_token);
              window.localStorage.setItem('expires_in',res.data.expires_in)
              window.localStorage.setItem('userInfo',JSON.stringify(res.data.userInfo))
                 localStorage.setItem('languageSet','en')
               this.$emit('childByValue',false)
               this.$emit('userInfo',res.data.userInfo);
            }
          })
        } else {
          return
        }

      },
      firstEvent() {
        if (this.phoneCode.phone != '' && this.phoneCode.code != '') {
          this.modify = 2;
        }
      },
      lastEvent() {
        if (this.modifys.setPassword != '' || this.modifys.confirmPassword != '') {
          if (this.modifys.setPassword != this.modifys.confirmPassword) {
            this.$message({
              showClose: true,
              message: '两次密码不一致',
              type: 'error'
            });
          } else {
            var data = {
              code: this.phoneCode.code,
              phone: this.phoneCode.phone,
              password: this.modifys.confirmPassword
            }
            this.$post('/User/changePass', data).then(res => {
              // 修改成功执行下一步
              if (res.code != 200) {

                  this.modify = 1;
              } else {

                  this.modify = 3
              }
            })
          }
        }
      },

      loginEvent() {
        // 去登陆页的时候清空所有input框
        this.passCode = {
          phone: '',
          code: ''
        }
        this.phoneCode = {
          phone: '',
          code: ''
        }
        this.modifys = {
          setPassword: '',
          confirmPassword: ''
        }
        this.modify = 0;
        this.formShow = true;
      },
      //忘记密码
      forgetEvent() {
        this.modify = 1;
        this.formShow = false;
        this.phoneCode = {
          phone: '',
          code: ''
        }
      },
      closeEvet() {
        this.modify = 0;
        this.formShow = true;
        this.showModel = false;
        this.$emit('childByValue', this.showModel)
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/login.css");
</style>



// WEBPACK FOOTER //
// src/components/login.vue